import Vue from "vue";
import VueRouter from "vue-router";

import jsRoutes from "routes.js.erb";

import FlashToast from "@/src/mixins/flashToast";
import VerifyPassword from "@/src/components/pre_auth/verify_password.vue";
import RequestEmail from "@/src/components/pre_auth/request_email.vue";

import { BootstrapVue } from "bootstrap-vue";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: '/:id', components: { VerifyPassword, RequestEmail },
      props: {
        VerifyPassword: (route) => {
          return {
            type: "item",
            ...route.params
          }
        },
        RequestEmail: (route) => {
          return {
            type: "item",
            ...route.params
          }
        }
      },
    },
    {
      path: '/collections/:id/:title?', components: { VerifyPassword, RequestEmail },
      props: {
        VerifyPassword: (route) => {
          return {
            type: "collection",
            ...route.params
          }
        },
        RequestEmail: (route) => {
          return {
            type: "collection",
            ...route.params
          }
        }
      }
    },
  ]
});

Vue.use(VueRouter);
Vue.use(BootstrapVue)

new Vue({
  el: "#vue",
  router: router,
  mixins: [FlashToast],
  data: function () {
    return {
      routes: jsRoutes
    }
  }
});
